<canvas
  baseChart
  [datasets]="chartData"
  [labels]="chartLabels"
  [options]="chartOptions"
  [type]="chartType"
></canvas>
